export default __webpack_public_path__ + "static/media/A2_11.86766e94.mp3";